module.exports = __webpack_public_path__ + "fonts/RenaultLife-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Bold.eot
// module id = 347
// module chunks = 0